export const parser = (text) => {
	// Выделение жирным первого слова текста
	let first = text.split(" ")[0]
	first = first[0].toUpperCase() + first.slice(1)
	const another = text.split(" ")
	another.shift()

	return [first, another.join(" ")]
}
